import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { HttpClient } from '@angular/common/http';
import { Polygon, MultiPolygon, FeatureCollection, Feature, Point } from '@turf/helpers';
import { firstValueFrom, filter, take, Subscription } from 'rxjs';
import { ChartData } from 'chart.js';
import { MapHelperService } from 'src/services/map-helper.service';
import { LayerAPIService } from 'src/app/features/shared/services/API/LayersAPI.service';
import * as wellknown from 'wellknown';
import { GeocoderComponent } from 'src/app/features/map-features/ui/organisms/geocoder/components/geocoder/geocoder.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UnileverService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Unilever.service';
import { PotentialZonesMapSectionService } from '../../../services/potentialZones-map-section.service';
import { PolygonSelectorWithLevelsComponent } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/components/polygon-selector-with-levels/polygon-selector-with-levels.component';
import { PolygonSelectorServiceType } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/helpers/EnumSelectorServices';
import { HierarchyLevel, SelectionHistoryItem, SelectionChangeEvent } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/models/polygon-selector-with-levels.models';
import { PolygonSelectorComponent } from 'src/app/features/map-features/ui/organisms/polygon-selector/components/polygon-selector/polygon-selector.component';
import { PolygonSelectionEvent } from 'src/app/features/map-features/ui/organisms/polygon-selector/models/polygon-selector.models';
import { EnumPolygonFillType } from 'src/app/features/map-features/ui/organisms/polygon-selector/helpers/enums/EnumPolygonFillType.enum';

@Component({
  selector: 'potential-zones-section',
  templateUrl: './potential-zones-section.component.html',
  styleUrls: ['./potential-zones-section.component.css'],
  animations: [
    trigger('mostrarPanel', [
      state('expanded', style({ opacity: 1, width: '*' })),
      state('retracted', style({ opacity: 0, width: '0px', overflow: 'hidden', display: 'none' })),
      transition('expanded <=> retracted', animate('300ms ease-in-out')),
    ])
  ]
})
export class PotentialZonesMapComponent implements OnInit, OnDestroy {
  
  // configuración del selector de poligonos
  @ViewChild('polygonSelector') polygonSelector: PolygonSelectorWithLevelsComponent;
  @ViewChild('agebSelector') agebSelector: PolygonSelectorComponent;
  @ViewChild('potentialZonesGeocoder') potentialZonesGeocoder: GeocoderComponent;

  isInitializing: boolean = true;
  isLoadingAgebs: boolean = false;
  hasInitialized: boolean = false;

  subscription_isVisible: Subscription;

  isMainPanelRetracted: boolean = false;

  hierarchyLevels: HierarchyLevel[] = [];
  selectorWithLevelsPrefixAdd: string = 'potential-zones';
  serviceType = PolygonSelectorServiceType.Potential_Zones;
  isPolygonSelectionWithevelsActive: boolean = true;
  simpleSelectorPolygonFillType = EnumPolygonFillType.Solid;
  agebCloropetConfig = this.potentialZonesMapSectionService.agebCloropetConfig;

  simpleSelectorPrefixAdd: string = 'agebs-selector';

  //dummy
  agebsPath: string = 'assets/regions_geoJson_dummy/agebs_cdmx/agebs_cdmx.geojson';
  agebsParentIdProperty: string = 'AgencyId';


  selectedHistory: SelectionHistoryItem[] = [];
  firstZone: { name: string, isSelected: boolean } = { name: 'Región Seleccionada', isSelected: false };
  secondZone: { name: string, isSelected: boolean, id: string} = { name: 'Zona Seleccionada', isSelected: false, id: null };

  agebsGeoJsonBackUp: FeatureCollection<Polygon | MultiPolygon> = null;
  agebsGeoJson: FeatureCollection<Polygon | MultiPolygon> = null;
  sortedFeatures: Feature<Polygon | MultiPolygon>[] = [];
  tableColumns: string[] = [];

  agebsLocationsGeoJsonBackUp: FeatureCollection<Polygon | MultiPolygon | Point> = null;
  agebsLocationsGeoJson: FeatureCollection<Polygon | MultiPolygon | Point> = null;

  // Categorías de AGEBs para los botones
  agebCategories: { name: string, isActive: boolean, color?: string, totalLocations?: number }[] = [
    { name: 'Todas', isActive: true, totalLocations: 0 },
    { name: 'TOP', isActive: false, totalLocations: 0 },
    { name: 'OPORTUNIDAD', isActive: false, totalLocations: 0 },
    { name: 'POBLACION', isActive: false, totalLocations: 0 },
    { name: 'NOMADA', isActive: false, totalLocations: 0 },
    { name: 'ZONA ROJA', isActive: false, totalLocations: 0 },
    { name: 'ZONA MAYA', isActive: false, totalLocations: 0 },
  ];

  // lo voy a poner como set por si hay varios para seleccionar, pero de momento sólo hayu uno
  selectedAgebIds: Set<string | number> = new Set();
  
  locationHash: Map<string, { lng: number, lat: number }> = new Map();
  searchLocation: string = '';

  pieChartData: ChartData<'pie'> = {
    labels: [],
    datasets: []
  };
  // chartColors: any[] = [
  //   {backgroundColor: 'rgba(75, 192, 192, 0.5)', borderColor: 'rgba(75, 192, 192, 1)'},
  //   {backgroundColor: 'rgba(153, 102, 255, 0.5)', borderColor: 'rgba(153, 102, 255, 1)'},
  //   {backgroundColor: 'rgba(255, 159, 64, 0.5)', borderColor: 'rgba(255, 159, 64, 1)'},
  //   {backgroundColor: 'rgba(255, 99, 132, 0.5)', borderColor: 'rgba(255, 99, 132, 1)'},
  //   {backgroundColor: 'rgba(54, 162, 235, 0.5)', borderColor: 'rgba(54, 162, 235, 1)'},
  //   {backgroundColor: 'rgba(255, 206, 86, 0.5)', borderColor: 'rgba(255, 206, 86, 1)'},
  //   {backgroundColor: 'rgba(201, 203, 207, 0.5)', borderColor: 'rgba(201, 203, 207, 1)'},
  labels : { name:string, count:number}[] = [];

  constructor(
    private mapHelperService: MapHelperService,
    private http: HttpClient,
    public potentialZonesMapSectionService: PotentialZonesMapSectionService,
    private layersAPIService: LayerAPIService,
    private unileverService: UnileverService
  ) { 
    this.subscription_isVisible = potentialZonesMapSectionService.isVisible.asObservable().subscribe( isVisible => {
      if(isVisible){
        this.initializeComponent();
      } else if (this.hasInitialized) {
        this.isInitializing = true;
        this.resetZones();
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.potentialZonesMapSectionService.setIsPotentialZonesVisible(false);
    this.potentialZonesMapSectionService.destroyLayers();

    this.subscription_isVisible?.unsubscribe();
  }

  async initializeComponent(): Promise<void> {
    this.isInitializing = true;
    this.hierarchyLevels = await this.potentialZonesMapSectionService.loadLayers();
    console.log("jerarquia selector",this.hierarchyLevels);
    this.loadCategoryColors();

    this.isInitializing = false;
    this.hasInitialized = true;
    this.mapHelperService.mapResize();
    // this.potentialZonesMapSectionService.initializePotentialZonesMapSection();
  }

  loadCategoryColors(): void {
    const cloropetConfig = this.potentialZonesMapSectionService.agebCloropetConfig;
    if (cloropetConfig && cloropetConfig.clases) {
      this.agebCategories.forEach(clase => {
        const category = cloropetConfig.clases.find(c => c.classProperty === clase.name);
        if (category) {
          clase.color = category.classValue;
        }else{
          clase.color = 'blue';
        }
      });
    }
    console.log("clases", this.agebCategories);
    
  }



  onHierarchySelectionChange(event: SelectionChangeEvent): void {
    console.log('zonas potenciales, cambio de seleccion', event);
    this.selectedHistory = event.history;

    if (event.history.length === 0) {
      this.resetZones();
      return;
    }

    if (event.history.length >= 1) {
      const firstSelection = event.history[0];
      this.firstZone = {
        name: firstSelection.description || 'Región Seleccionada',
        isSelected: true
      };
    }else{
      this.firstZone = { name: 'Región Seleccionada', isSelected: false };
    }

    if (event.history.length >= 2) {
      const secondSelection = event.history[1];
      this.secondZone = {
        name: secondSelection.description || 'Zona Seleccionada',
        isSelected: true,
        id: secondSelection.selectedId
      };

      if (this.polygonSelector) {
        this.isPolygonSelectionWithevelsActive = false;
      }
      this.loadAgebsAndActivateSelector(secondSelection.selectedId);
    }else{
      this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null};
      this.resetAgebs();
    }
  }

  onAgebSelectionChange(event: PolygonSelectionEvent): void {
    console.log('zonas potenciales, ageb seleccionado:', event);
    this.onAgebSelected(event.selectedFeatures);
  }

  async loadAgebsAndActivateSelector(agencyId: string): Promise<void> {
    try {
      // const fullGeoJson = await this.loadGeoJsonDummy(this.agebsPath);
      this.isLoadingAgebs = true;
      this.potentialZonesMapSectionService.setLoading(true);
      // const fullGeoJson = await this.loadGeoJson(this.hierarchyLevels[this.hierarchyLevels.length - 1].key, this.selectedHistory[this.selectedHistory.length - 1].selectedId);
      const [fullGeoJson, fullLocationGeoJson] = await Promise.all([
        this.loadAgebGeoJson(this.hierarchyLevels[this.hierarchyLevels.length - 1].key, this.selectedHistory[this.selectedHistory.length - 1].selectedId),
        this.loadLocationsGeoJson(this.hierarchyLevels[this.hierarchyLevels.length - 1].key, this.selectedHistory[this.selectedHistory.length - 1].selectedId)
      ]);
      this.agebsGeoJson = fullGeoJson as FeatureCollection<Polygon | MultiPolygon>;

      const centerLng = -98.884194;
      const centerLat = 19.502903;
      const geoJsonDataDummy = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [centerLng + 0.01, centerLat + 0.01]
            },
            properties: {
              _Id: '1583',
              name: 'Tienda Ramon Juan',
              description: 'Punto de alta frecuencia de visitas',
              frecuencia: 'Quincenal',
              tipo: 'Preventa',
              dia: 'Lunes',
              Frecuencia_mensual: 'Q1',
              territorio: '1209345',
              icon: 'service.png',
              activeIcon: 'serviceA.png',
              TipoZona: 'TOP'
            }
          },
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [centerLng - 0.01, centerLat + 0.005]
            },
            properties: {
              _Id: '1582',
              name: 'Tienda Central',
              description: 'Zona comercial con tráfico moderado',
              frecuencia: 'Quincenal',
              tipo: 'Preventa',
              dia: 'Lunes',
              Frecuencia_mensual: 'Q1',
              territorio: '1209345',
              icon: 'service.png',
              activeIcon: 'serviceA.png',
              TipoZona: 'POBLACION'
            }
          },
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [centerLng + 0.005, centerLat - 0.01]
            },
            properties: {
              _Id: '1580',
              name: 'Centro comercial La Fe',
              description: 'Área residencial con visitas frecuentes',
              frecuencia: 'Quincenal',
              tipo: 'Preventa',
              dia: 'Lunes',
              Frecuencia_mensual: 'Q1',
              territorio: '1209345',
              icon: 'service.png',
              activeIcon: 'serviceA.png',
              TipoZona: 'OPORTUNIDAD'
            }
          }
        ]
      };
      this.agebsLocationsGeoJson = fullLocationGeoJson as FeatureCollection<Point>;4
      console.log("selector features", this.agebsLocationsGeoJson);
      

      //dummy
      // const filteredFeatures = fullGeoJson.features.filter(
      //   feature => feature.properties && feature.properties[this.agebsParentIdProperty] == agencyId
      // );
      // console.log('zonas potenciales, ageb geo', agencyId, fullGeoJson, filteredFeatures);
      // if (filteredFeatures.length == 0) {
      //   console.log('No se encontraron agebs para la agencia:', agencyId);
      //   return;
      // }
      // this.agebsGeoJson = {
      //   type: 'FeatureCollection',
      //   features: filteredFeatures
      // };


      this.agebsGeoJsonBackUp = JSON.parse(JSON.stringify(this.agebsGeoJson));
      this.agebsLocationsGeoJsonBackUp = JSON.parse(JSON.stringify(this.agebsLocationsGeoJson));
      this.updateTableColumns();
      this.sortFeatures();

      this.updateCategoriesLocationCounts()
      
      console.log("zonas potenciales, ageb geo",this.agebsGeoJson);
      this.updatePieChart();
      // this.mapHelperService.FitBounds(this.agebsGeoJson);
      
      if (this.agebSelector) {
        await this.agebSelector.activate();
        this.potentialZonesMapSectionService.setLoading(true);
        this.agebSelector.loadGeoJson(this.agebsGeoJson);
        this.agebSelector.sendToTop();

        this.potentialZonesMapSectionService.loadLocationsGeoJson(this.agebsLocationsGeoJson);
        this.potentialZonesMapSectionService.sendLocationsToTop();

        await this.mapHelperService.waitForMapToRender();
        this.potentialZonesMapSectionService.setLoading(false);
      }

      this.isLoadingAgebs = false;
      this.potentialZonesMapSectionService.setLoading(false);
    } catch (error) {
      this.isLoadingAgebs = false;
      this.potentialZonesMapSectionService.setLoading(false);
      console.log('error cargando agebs', error);
    }
  }
  
  onAgebSelected(featureCollection: FeatureCollection<Polygon | MultiPolygon>): void {
    console.log('ageb', featureCollection);

    this.selectedAgebIds.clear();
    featureCollection.features.forEach(feature => {
      if (feature.id != null) {
        this.selectedAgebIds.add(feature.id);
      }
    });

    if (this.agebsGeoJson)
        this.sortedFeatures = this.agebsGeoJson.features;
    if(this.selectedAgebIds.size > 0 ){
      this.sortFeatures();
    }
  }

  selectAgebByTable(feature: any): void {
    if (feature.id != null && this.agebSelector) {
      if (this.isAgebSelected(feature)) {
        // ya está seleccionado, deseleccionarlo
        this.agebSelector.deselectAll();
        this.selectedAgebIds.clear();
      } else {
        this.agebSelector.deselectAll();
        this.agebSelector.selectById(feature.id);
      }
    }
  }

  isAgebSelected(feature: any): boolean {
    const featureId = feature.id;
    return this.selectedAgebIds.has(featureId);
  }

  sortFeatures(): any[] {
    if (!this.agebsGeoJson) 
      return;

    this.sortedFeatures = [...this.agebsGeoJson.features].sort((a, b) => {
      const aSelected = this.isAgebSelected(a);
      const bSelected = this.isAgebSelected(b);

      if (aSelected && !bSelected) 
        return -1;
      if (!aSelected && bSelected) 
        return 1;
    });
  }
  
  selectCategory(category: { name: string, isActive: boolean }): void {
    this.agebCategories.forEach(c => c.isActive = false);
    category.isActive = true;
    
    console.log('categoria', category.name);
    if (category.name === 'Todas') {
      this.agebsGeoJson = this.agebsGeoJsonBackUp;
      // this.agebsLocationsGeoJson = this.agebsLocationsGeoJsonBackUp;
    } else {
      const filteredFeatures = this.agebsGeoJsonBackUp.features.filter(feature => {
        return feature.properties && feature.properties['TipoZona'] === category.name;
      });
      this.agebsGeoJson = {
        type: 'FeatureCollection',
        features: filteredFeatures
      };

      // const filteredLocationFeatures = this.agebsLocationsGeoJsonBackUp?.features?.filter(feature => {
      //   return feature.properties && feature.properties['TipoZona'] === category.name;
      // });
      // this.agebsLocationsGeoJson = {
      //   type: 'FeatureCollection',
      //   features: filteredLocationFeatures
      // };
    }
    
    if (this.agebSelector) {
      this.agebSelector.deselectAll();
      this.agebSelector.loadGeoJson(this.agebsGeoJson);

      // this.potentialZonesMapSectionService.loadLocationsGeoJson(this.agebsLocationsGeoJson);
    }
    this.selectedAgebIds.clear();
    this.sortFeatures();
  }

  resetZones(): void {
    this.firstZone = { name: 'Región Seleccionada', isSelected: false };
    this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null };
    this.resetAgebs();
  }

  resetAgebs(): void {
    this.agebsGeoJson = null;
    this.agebsGeoJsonBackUp = null;
    this.sortedFeatures = [];
    this.selectedAgebIds.clear();
    
    this.agebCategories.forEach(c => c.isActive = false);
    this.agebCategories[0].isActive = true; 

    this.labels = [];
    this.pieChartData = {
      labels: [],
      datasets: []
    };

    this.potentialZonesGeocoder?.clearSearch();
    
    if (this.polygonSelector) {
      this.isPolygonSelectionWithevelsActive = true;
    }
    
    if (this.agebSelector) {
      this.agebSelector.clearGeoJson();
      this.agebSelector.deactivate();
    }
    this.potentialZonesMapSectionService.clearLocations();
    this.locationHash.clear();
  }

  async goBack(): Promise<void> {
    if (this.secondZone.isSelected) {
      this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null };
      this.resetAgebs();
      
      // Reactivar el selector de polígonos con niveles
      if (this.polygonSelector) {
        this.isPolygonSelectionWithevelsActive = true;
        this.polygonSelector.restoreFullGeoJsonForCurrentLevel();
      }
    } else {
      if (this.polygonSelector) {
        await this.polygonSelector.goToPreviousLevel();
      }
    }
  }

  async resetToStart(): Promise<void> {
    this.resetZones();
    this.mapHelperService.FlyToCamera(
      this.mapHelperService.Lat.toString(),
      this.mapHelperService.Lng.toString(),
      this.mapHelperService.Zoom.toString(),
      0
    );
    
    if (this.polygonSelector) {
      const resetAll = false;
      await this.polygonSelector.resetToInitialLevel(resetAll);
    }
  }


  async loadAgebGeoJson(zoneName: string, selectedZoneId: string): Promise<FeatureCollection<Polygon | MultiPolygon | Point>> {
    const geoResp = await firstValueFrom(this.layersAPIService.GetLayerDataFilteredByNameGeojson(zoneName, selectedZoneId).pipe(take(1)));
    console.log("selector, loadGeoJson layer", geoResp);
  
    var geoJson: FeatureCollection<Polygon | MultiPolygon> = null;
    try {
      if (geoResp.isSuccess) {
        const dataArray = JSON.parse(geoResp.result) as { [key: string]: any }[];
        
        const features: GeoJSON.Feature<Polygon | MultiPolygon>[] = [];
        
        dataArray.forEach((item, index) => {
          if (item.GeomJson) {
            try {
              let geometry: any = null;
              
              // va a checar si es wk o es GeoJson, si es geojson lo parsea directo, si es wk usa el wellknown
              const geomStr = item.GeomJson.trim();
              if (geomStr.startsWith('{') || geomStr.startsWith('[')) {
                geometry = JSON.parse(geomStr);
              } else if (geomStr.match(/^(POINT|LINESTRING|POLYGON|MULTIPOINT|MULTILINESTRING|MULTIPOLYGON|GEOMETRYCOLLECTION)/i)) {
                geometry = wellknown.parse(geomStr);
                if (!geometry) {
                  console.log("selector, error parseando wellknown para el item ", index, geomStr);
                  return;
                }
              } else {
                console.log("selector, formato de geometría desconocido para el item ", index, geomStr);
                return;
              }
              
              const properties = { ...item };
              delete properties['GeomJson'];
              
              const feature: GeoJSON.Feature<Polygon | MultiPolygon> = {
                type: 'Feature',
                id: index + 1,
                geometry: geometry,
                properties: properties
              };
              
              features.push(feature);
            } catch (parseError) {
              console.log(`selector, error parseando el diccionario`, parseError);
            }
          }
        });
          
        geoJson = {
          type: 'FeatureCollection',
          features: features
        };
          
      } else {
        console.log("selector, no hubo respuesta del servicdor");
        Sentry.captureMessage('PotentialZonesSectionComponent.loadAgebGeoJson: isSuccess false', { level: 'warning', extra: { response: geoResp } });      
      }
    } catch (error) {
      console.log("selector, error parseando el geojson", error);
    }
      
    return geoJson;
  }

  async loadLocationsGeoJson(zoneName: string, selectedZoneId: string): Promise<FeatureCollection<Point>> {
    const geoResp = await firstValueFrom(this.unileverService.GetLocationsByAGEBbyZoneUI(selectedZoneId).pipe(take(1)));
    console.log("selector, loadGeoJson ubicaciones", geoResp);
  
    var geoJson: FeatureCollection<Point> = null;
    try {
      if (geoResp.isSuccess && geoResp.result?.locationsByZone_Geojson) {
        geoJson = JSON.parse(geoResp.result.locationsByZone_Geojson) as FeatureCollection<Point>;
        
        geoJson.features.forEach((feature, index) => {
          if(feature.properties && feature.properties['Identifier']){
            this.locationHash.set(feature.properties['Identifier'], { lng: feature.geometry.coordinates[0], lat: feature.geometry.coordinates[1] });
          }
        });
      } else {
        console.log("selector, no hubo respuesta del servicdor");
        Sentry.captureMessage('PotentialZonesSectionComponent.loadLocationsGeoJson: isSuccess false', { level: 'warning', extra: { response: geoResp } });      
      }
    } catch (error) {
      console.log("selector, error parseando el geojson", error);
    }
      
    return geoJson;
  }

  async loadGeoJsonDummy(path: string): Promise<GeoJSON.FeatureCollection<Polygon | MultiPolygon>> {
    const geoJson = await firstValueFrom(this.http.get(path)) as GeoJSON.FeatureCollection<Polygon | MultiPolygon>;
    console.log("zonas potenciales, carga de geoJson", geoJson);
      
    geoJson.features.forEach((feature, index) => {
      if (feature.id == undefined || feature.id == null) 
        feature.id = index + 1;
    });
    return geoJson;
  }

  updatePieChart(): void {
    if (!this.agebsGeoJsonBackUp) 
      return;
    
    this.labels = [];
    
    this.agebsGeoJson.features.forEach(feature => {
      const categoria = feature.properties?.['TipoZona'];
      if(!this.labels.some(l => l.name === categoria)){
        this.labels.push({ name: categoria, count: 1 });
      }else{
        const label = this.labels.find(l => l.name === categoria);
        label.count += 1;
      }
    });

    if (this.labels.length == 0) {
      this.pieChartData = {
        labels: [],
        datasets: []
      };
      return;
    }

    //va a obtener los colores de las categoria, no del aray predefinido, para que sea como acotacion
    const backgroundColors = this.labels.map(label => {
      const category = this.agebCategories.find(c => c.name === label.name);
      const color = category?.color || '#0000ff';
      return this.hexToRgba(color, 0.6);
    });

    const borderColors = this.labels.map(label => {
      const category = this.agebCategories.find(c => c.name === label.name);
      return category?.color || '#0000ff';
    });

    this.pieChartData = {
      labels: this.labels.map(l => l.name),
      datasets: [{
        data: this.labels.map(l => l.count),
        backgroundColor: backgroundColors,
        borderColor: borderColors
      }]
    };
  }

  hexToRgba(hex: string, alpha: number = 1): string {
    if(hex.startsWith('rgba')) {
      return hex;
    }

    if(hex.startsWith('rgb')) {
      const rgba = hex.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
      return rgba;
    }

    if (!hex.startsWith('#')) {
      console.warn('Color hex inválido, se esperaba formato #RRGGBB:', hex);
      return `rgba(0, 0, 255, ${alpha})`;
    }

    hex = hex.replace('#', '');
    
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  updateTableColumns(): void {
    if (!this.agebsGeoJson || this.agebsGeoJson.features.length === 0) {
      this.tableColumns = [];
      return;
    }

    const allProperties = new Set<string>();
    this.agebsGeoJson.features.forEach(feature => {
      if (feature.properties) {
        Object.keys(feature.properties).forEach(key => allProperties.add(key));
      }
    });

    this.tableColumns = Array.from(allProperties);
  }

  updateCategoriesLocationCounts(): void {
    if (!this.agebsGeoJson || !this.agebsLocationsGeoJson) 
      return;

    var totalLocations = 0;
    this.agebCategories.forEach(category => {
      const count = this.agebsLocationsGeoJson.features.filter(feature => {
        return feature.properties && feature.properties['TipoZona'] === category.name;
      }).length;
        category.totalLocations = count;
        totalLocations += count;
    });
    this.agebCategories.find(c => c.name === 'Todas').totalLocations = totalLocations;
  }

  retractMainPanel(): void {
    this.isMainPanelRetracted = !this.isMainPanelRetracted;
  }
}
